import React from 'react'
import ReactDOM from 'react-dom'

import ApplicationProvider from './ApplicationProvider'

const renderRoot = (RootComponent) => {
  ReactDOM.render(<RootComponent />, global.document.getElementById('root'))
}

renderRoot(ApplicationProvider)

if (module.hot) {
  module.hot.accept('./ApplicationProvider', () => {
    renderRoot(ApplicationProvider)
  })
}



// WEBPACK FOOTER //
// ./src/index.js